module.exports = __webpack_public_path__ + "static/media/other.97582ec6.svg";